export enum ClientFilterTypes {
  Company = 'company',
}
